module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921074149_T.e4b70a0c.jpg";